var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement: 'top' }),expression:"{ placement: 'top' }"}],attrs:{"title":"Change transcription language"},on:{"click":_vm.showModal}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faGlobeEurope}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3427791e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-components/activity-summary/components/secondary-actions/ChangeTranscriptionLanguage/ChangeTranscriptionLanguageButton.vue
// module id = AzeC
// module chunks = 1